import { QuestionRadioButtonsField, QuestionYesNoField, QuestionDropDownField, QuestionMultiCheckBoxField } from 'components/Questionnaires/fields';
import { requiredValidator } from 'components/Questionnaires/validators';
import { getKey, DocumentKeys } from 'common/forms/documentTypes';
import { uploadSupportingDocField } from 'common/questionnaires/definitions/fields';

export function qualifiedIntermediaryBlock({ visible }) {
  const isQi = bAnswers => bAnswers?.entity === '1' || bAnswers?.entity === '3';
  const isQdd = bAnswers => bAnswers?.entity === '2' || bAnswers?.entity === '3';
  const isQslStatementVisible = bAnswers => bAnswers?.additionalResponsibilities?.includes('3');
  const isChapter4RatePoolVisible = bAnswers => bAnswers?.responsibility === '2';
  const isIntermediaryRatePoolVisible = bAnswers => bAnswers?.responsibility === '2';
  const isSimpleWhdStatementVisible = bAnswers => isQi(bAnswers) && bAnswers?.responsibility === '1';
  const isPooledWhdStatementVisible = bAnswers => isQi(bAnswers) && bAnswers?.responsibility === '2';

  return {
    id: 'qualifiedIntermediary',
    title: 'questionnaire.ch3.qualifiedIntermediary',
    component: undefined,
    info: {
      instructions: 'questionnaire.ch3.qualifiedIntermediary.info',
    },
    visible,
    questions: [
      {
        id: 'entity',
        label: 'questionnaire.ch3.qualifiedIntermediary.entity.label',
        component: QuestionRadioButtonsField,
        componentProps: {
          items: 'questionnaire.ch3.qualifiedIntermediary.entity.items',
          inputName: 'entity'
        },
        visible: true,
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.qualifiedIntermediary.entity.errorMessage' }
          ]
        }
      },
      {
        id: 'responsibility',
        label: 'questionnaire.ch3.qualifiedIntermediary.responsibility.label',
        component: QuestionRadioButtonsField,
        componentProps: {
          items: 'questionnaire.ch3.qualifiedIntermediary.responsibility.items',
          inputName: 'responsibility'
        },
        visible: isQi,
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.qualifiedIntermediary.responsibility.errorMessage' }
          ]
        }
      },
      {
        id: 'additionalResponsibilities',
        label: 'questionnaire.ch3.qualifiedIntermediary.additionalResponsibilities.label',
        component: QuestionMultiCheckBoxField,
        componentProps: {
          items: 'questionnaire.ch3.qualifiedIntermediary.additionalResponsibilities.items',
          inputName: 'additionalResponsibilities'
        },
        visible: isQi
      },
      {
        id: 'chapter4RatePool',
        component: QuestionYesNoField,
        visible: isChapter4RatePoolVisible,
        label: 'questionnaire.ch3.qualifiedIntermediary.chapter4RatePool.label',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.qualifiedIntermediary.chapter4RatePool.errorMessage' }
          ]
        }
      },
      {
        id: 'intermediaryRatePool',
        component: QuestionYesNoField,
        visible: isIntermediaryRatePoolVisible,
        label: 'questionnaire.ch3.qualifiedIntermediary.intermediaryRatePool.label',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.qualifiedIntermediary.intermediaryRatePool.errorMessage' }
          ]
        }
      },
      uploadSupportingDocField({
        id: 'simpleWhdStatement',
        docType: getKey(DocumentKeys.SIMPLE_WHD_STATEMENT),
        visible: isSimpleWhdStatementVisible,
        hasFootnote: true,
        isRequired: false
      }),
      uploadSupportingDocField({
        id: 'pooledWhdStatement',
        docType: getKey(DocumentKeys.POOLED_WHD_STATEMENT),
        visible: isPooledWhdStatementVisible,
        hasFootnote: true
      }),
      uploadSupportingDocField({
        id: 'qslStatement',
        docType: getKey(DocumentKeys.QSL_STATEMENT),
        visible: isQslStatementVisible,
      }),
      {
        id: 'qddType',
        label: 'questionnaire.ch3.qualifiedIntermediary.qddType.label',
        component: QuestionDropDownField,
        componentProps: {
          items: 'questionnaire.ch3.qualifiedIntermediary.qddType.items'
        },
        visible: isQdd,
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.qualifiedIntermediary.qddType.errorMessage' }
          ]
        }
      },
      uploadSupportingDocField({
        id: 'qddDocumentation',
        docType: getKey(DocumentKeys.QDD_DOCUMENTATION),
        isRequired: false,
        visible: isQdd,
      }),

    ]
  };
}

export default qualifiedIntermediaryBlock;
